module.exports = __webpack_public_path__ + "static/img/logo_login.cca1101c.png";